import type { AllTokens } from "../../domain/entities/AllTokens";

const readString = (source: Record<string, unknown>, ...keys: string[]): string => {
  for (const key of keys) {
    const value = source[key];
    if (typeof value === "string" && value) {
      return value;
    }
  }

  return "";
};

const readLoginTokenSources = (
  apiData: Record<string, unknown>,
): Record<string, unknown>[] => {
  const sources: Record<string, unknown>[] = [apiData];

  for (const key of ["tokens", "auth", "token"]) {
    const nested = apiData[key];
    if (nested && typeof nested === "object") {
      sources.push(nested as Record<string, unknown>);
    }
  }

  return sources;
};

export const mapLoginTokens = (
  apiData: Record<string, unknown>,
): Pick<AllTokens, "access_token" | "refresh_token" | "temp_access_token"> => {
  const sources = readLoginTokenSources(apiData);

  const pick = (...keys: string[]): string => {
    for (const source of sources) {
      const value = readString(source, ...keys);
      if (value) {
        return value;
      }
    }

    return "";
  };

  return {
    access_token: pick("access_token", "accessToken", "token"),
    refresh_token: pick("refresh_token", "refreshToken"),
    temp_access_token: pick("temp_access_token", "tempAccessToken", "temp_token"),
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapApiTokens = (result: any): AllTokens => {
  const accessToken =
    result?.access_token ?? result?.accessToken ?? result?.token ?? "";
  const refreshToken =
    result?.refresh_token ?? result?.refreshToken ?? "";
  const tempToken =
    result?.temp_access_token ??
    result?.tempAccessToken ??
    result?.temp_token ??
    accessToken;

  return {
    access_token: accessToken,
    refresh_token: refreshToken,
    temp_access_token: tempToken,
  };
};
